export default "__VITE_ASSET__29cf31ad__"